import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Sun, Moon, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/create", label: "Create Invoice" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { theme, toggleTheme } = useApp();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 glass border-b border-border/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2">
          <img src="/logo192.png" alt="Simple Invoice" className="w-9 h-9 rounded-xl shadow-sm" />
          <span className="font-heading font-bold text-lg tracking-tight">Simple Invoice</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-lg transition-colors duration-200 ${
                  isActive
                    ? "text-blue-600 dark:text-blue-400 font-medium"
                    : "text-muted-foreground hover:text-foreground hover:bg-accent"
                }`
              }
              end
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={toggleTheme}
            data-testid="theme-toggle"
            aria-label="Toggle theme"
            className="w-9 h-9 rounded-lg grid place-items-center hover:bg-accent transition-colors duration-200"
          >
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <Link to="/create" className="hidden sm:block">
            <Button data-testid="header-create-btn" className="rounded-full bg-blue-600 hover:bg-blue-700 text-white">
              Create Invoice
            </Button>
          </Link>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="md:hidden w-9 h-9 rounded-lg grid place-items-center hover:bg-accent"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border/60 bg-background/95 backdrop-blur">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm rounded-lg ${
                    isActive ? "text-blue-600 dark:text-blue-400 font-medium" : "text-muted-foreground"
                  }`
                }
                end
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
